import { AfterViewInit, ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { GridComponent, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { fadeInOut } from '../../../../shared/helpers/animations';
import { AuthorizationService, LLDashboardService, StorageManagerService } from '../../../../shared/services';
import { DomSanitizer } from '@angular/platform-browser';
import { DeleteButtonComponent } from '../../../common/delete-button/delete-button.component';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations/src';
import { Utilities } from '../../../../shared/services/utilities';
import { EsigModalComponent } from '../../../common/esig-modal/esig-modal.component';

@Component({
    selector: 'app-product-labeling-listing',
    templateUrl: './product-labeling-listing.component.html',
    styleUrls: ['./product-labeling-listing.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.Emulated
})
export class ProductLabelingListingComponent implements OnInit, AfterViewInit {
    @ViewChild('LLForm_grid')
    public LLForm_grid: GridComponent;
    @ViewChild('drafts_grid')
    public draftsGrid: GridComponent;
    @ViewChild('deliveries_grid')
    public deliveriesGrid: GridComponent;
    @ViewChild('deleteSPLButton')
    public deleteButton: DeleteButtonComponent;
    @ViewChild('deleteSPLDraftButton')
    public deleteButtonDrafts: DeleteButtonComponent;
    @ViewChild('sendToFDAButton')
    public sendToFDAButton: EsigModalComponent;
    @ViewChildren(NgbTabset) viewChildren: QueryList<NgbTabset>;
    public tabset: NgbTabset;

    @ViewChild('tooltip')
    public tooltip: TooltipComponent;

    LLForm_grid_data = [];
    public initialPage: Object;
    public sortOptions: Object;
    public formatOptions: any;
    public toolbarOptions: Object;
    count_LLForm: number;
    loading = false;
    submitted = false;
    public searchForm: UntypedFormGroup;
    errorMessage: string;
    bHasPermission = false;
    hasDeletePermission = false;
    dashboardDeliveriesData = [];
    formData: any;
    sub: Subscription;
    activeTab = 'LLFormGrid'; // default
    selectedLLRevisionId: number | undefined;
    selectedLLOrderId: number | undefined;
    selectedLLRevisionDraftMode: boolean | undefined;
    selectedLLRevisionProductType: string | undefined;
    selectedLLRevisionFileName: string | undefined;
    selectedLLRevisionVersion: string | undefined;

  public clipmodecolumn = { class: 'e-tooltipcolumn' };

    constructor (private router: Router, private route: ActivatedRoute, private storageManagerService: StorageManagerService,
        private fb: UntypedFormBuilder, private authorizationService: AuthorizationService, private toastr: ToastrService, private cdRef: ChangeDetectorRef, private sanitizer: DomSanitizer,
        private dashboardService: LLDashboardService) {
  }

  toHtml(input): any {
    return input ? new DOMParser().parseFromString(input, 'text/html').documentElement.textContent : '';
  }

  public encodeHtml(str) {
    const buf = [];
    if (str) {
      for (let i = str.length - 1; i >= 0; i--) {
        buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
      }

      return buf.join('');
    }
  }

  public decodeHtml(str) {

    if (str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    }
  }

  ngAfterViewInit(): void {

    this.sub = this.viewChildren.changes.subscribe((comps: QueryList<NgbTabset>) => {
      this.tabset = comps?.first;
      this.cdRef.detectChanges();

      this.activeTab = this.tabset.activeId;
    });
  }

  tooltipValue(args) {

    let grid;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {

      switch (this.activeTab) {
        case 'drafts':
          grid = this.draftsGrid;
          break;
        case 'deliveries':
          grid = this.deliveriesGrid;
          break;

        default:
          grid = this.LLForm_grid;
          break;
      }

      const rowInfo = grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltip.cssClass = 'customTooltip';
      this.tooltip.content = this.toBrackets(rowData[(rowInfo.column as any).field]);
    }
  }

  toBrackets(str) {
    const retVal = str.split('&lt;').join('<')
      .split('&gt;').join('>')
      .split('&amp;').join('&');
      // .split('&apos;').join("'")
      // .split('&quot;').join('"')
      // .split('&colon;').join(':')
      // .split('&excl;').join('!')
      // .split('&sol;').join('/')
      // .split('&bsol;').join('\\')
      // .split('&vert;').join('|')
      // .split('&quest;').join('?')
      // .split('&ast;').join('*');

     return retVal;
  }

  tabChanged(event) {
    this.activeTab = event.nextId;
    const isDeleteAllowedOnTab = this.activeTab !== 'deliveries'
    this.llFormGridRowDeselected();
    this.toolbarOptions = this.createCustomToolbarItems(this.hasDeletePermission, isDeleteAllowedOnTab, this.bHasPermission);
    this.selectedLLRevisionId = undefined;
  }

    ngOnInit(): void {

        this.searchForm = this.fb.group({
            searchText: ['', { validators: [Validators.required], updateOn: 'blur' }]
        });

      this.initialPage = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100, 'All'] };
      this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() + ' hh:mm a' };

        this.formData = this.route.snapshot.data['formData'];
        if (this.formData) {
            if (this.formData.error) {
                this.toastr.error(this.formData.error);
                this.formData = null;
            } else if (!Array.isArray(this.formData)) {
                this.toastr.error(this.formData);
                this.formData = null;
            } else {

              if (this.formData[0] && this.formData[0].data) {
                    this.LLForm_grid_data = this.formData[0].data;
                    this.count_LLForm = this.LLForm_grid_data.length;
                }

              if (this.formData[1] && this.formData[1].data) {
                    this.dashboardDeliveriesData = this.formData[1].data;
                }
            }
        }

        // Check if user has write permission. If no, disable the "Save", "Save a draft" buttons
        this.checkUserPermission();
        this.toolbarOptions = this.createCustomToolbarItems(this.hasDeletePermission, true, this.bHasPermission);

        // Fix for footer spacing issues
        document.getElementsByTagName('footer')[0].classList.add("footer-spacing-fix");

        // set focus on the invisible div so the first tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
        this.initTabIndex();
    }

    initTabIndex() {
      (document.activeElement as HTMLElement).blur();

      const main = document.getElementById("firstDiv");

      if (main) {
        main.focus();
      }
    }

    downloadFile(filePath: string, fileName: string) {

        this.sub = this.dashboardService.downloadFile(filePath, fileName).subscribe(response => {
            const URL = window.URL || (<any>window).webkitURL;
            const downloadUrl = URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            link.click();
        },
            error => {
              this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
            }
        );
    }

    // Change grid filter operator from "startwith" to "contains" for columns that are string
    public begin(args: any): void {
        if (args.requestType === 'filtering') {
            if (args.columns) {
                args.columns.forEach(col => {
                  switch (args.currentFilteringColumn) {
                    case 'formVersion':
                      args.currentFilterObject.value = `${ args.currentFilterObject.value }.0`;
                      break;
                        case 'modifiedDate':
                            break;
                        default:
                            col.operator = 'contains';       // set the “contains” operator for the column
                            break;
                    }
                });
            }
        }
    }

  // Display detail of a single LL form
  viewFormOrGoToDashboard(llRevisionId: string, isDraftMode: boolean) {
    if (llRevisionId) {
      const url = isDraftMode ? '/products/ll-form' : '/products/dashboard';
      this.router.navigate([url, llRevisionId]);
    }
  }

    // Check if user has write permission. If no, disable the "Save", "Save a draft" buttons
    checkUserPermission() {
        if (this.authorizationService.hasPermission('SSDP.CanWriteLLForm')) {
            this.bHasPermission = true;
        }
        if (this.authorizationService.hasPermission('SSDP.CanDeleteLLForm')) {
            this.hasDeletePermission = true;
        }
    }

    createCustomToolbarItems(deletePermission : boolean, isDeleteAllowedOnTab: boolean, writePermission: boolean){
      let toolbarItems = [];

        if (this.activeTab === 'deliveries' && writePermission) {
          toolbarItems.push(
            {
              text: 'Send to FDA',
              tooltipText: 'Send to FDA',
              prefixIcon: 'fas fa-paper-plane',
              id: 'tool-bar-send'
            }
          );
        }

        if (writePermission) {
            toolbarItems.push(
                {
                    text: 'Create New Product',
                    tooltipText: 'Add a new Product to this list',
                    prefixIcon: 'fas fa-plus',
                    id: 'create-form-btn'
                }
            );
        }

        if(deletePermission && isDeleteAllowedOnTab){
          toolbarItems.push(
            {
              text: 'Delete Product',
              tooltipText: 'Delete the selected SPL',
              prefixIcon: 'fas fa-trash',
              id: 'tool-bar-delete'
            }
          );
        }

        toolbarItems.push('Search');

        return toolbarItems;
      }

    getStatusClass(status) {
        let cssClass;

        if (status) {

            switch (+status) {

                case 3:

                    cssClass = 'text-success';
                    break;

                case 4:

                    cssClass = 'text-danger';
                    break;
            }
        }
        return cssClass;
    }

    getStatusIcon(status) {
        let cssClass;

        if (status) {

            switch (status) {

                case 1:
                case 2:
                    cssClass = 'fas fa-spinner text-info';
                    break;
                case 3:

                    cssClass = 'fas fa-check-circle text-success';
                    break;

                case 4:

                    cssClass = 'fas fa-window-close text-danger';
                    break;
            }
        }
        return cssClass;
    }

    customizeCell(args: QueryCellInfoEventArgs) {
        if (args.column.field === 'statusDescription') {
            if (args.data['taskStatusId'] === 1 || args.data['taskStatusId'] === 2) {
                // args.cell.classList.add('text-info');
                (args.cell as any).style.color = '#17a2b8' ;
            } else if (args.data['taskStatusId'] === 3) {
                (args.cell as any).style.color = '#77b800' ;
            } else if (args.data['taskStatusId'] === 4) {
                (args.cell as any).style.color = '#a94442' ;
            }
        }
    }

    llFormGridRowSelected(e: any){
        this.selectedLLRevisionId = e.data.llRevisionId;
        this.selectedLLRevisionDraftMode = e.data.isDraftMode;

        this.selectedLLRevisionProductType = e.data.productType;
        this.selectedLLRevisionVersion = e.data.formVersion;
    }

    llFormGridRowDeselected() {
        this.selectedLLRevisionId = undefined;
        this.selectedLLRevisionDraftMode = undefined;
        this.selectedLLOrderId = undefined;
        this.selectedLLRevisionProductType = undefined;
        this.selectedLLRevisionFileName = undefined;
        this.selectedLLRevisionVersion = undefined;
    }

    llDeliveriesGridRowSelected(e: any){
        this.selectedLLRevisionId = e.data.formRevisionId;
        this.selectedLLOrderId = e.data.orderId;
        this.selectedLLRevisionProductType = e.data.productType;
        this.selectedLLRevisionFileName = e.data.fileName;
        this.selectedLLRevisionVersion = e.data.formVersion;
    }

    // convenience getter for easy access to form fields
    get f() { return this.searchForm.controls; }

    rowSelecting(e) {
      e.cancel = e.isHeaderCheckboxClicked;

      if (this.LLForm_grid && this.LLForm_grid.getSelectedRecords().length > 0) {
        this.LLForm_grid.clearSelection();
      } else if (this.deliveriesGrid && this.deliveriesGrid.getSelectedRecords().length > 0) {
        this.deliveriesGrid.clearSelection();
      }
    }

    onSubmitionToFDA(isSuccessfulySubmitted: boolean) {
      if (isSuccessfulySubmitted) {
        if (this.deliveriesGrid) {
          this.deliveriesGrid.clearSelection();
        }
      }
    }

  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'create-form-btn' && this.bHasPermission) {
        this.router.navigate(["/create-ll-form"]);
    }
    else if (args.item.id === 'tool-bar-delete') {
        if(this.LLForm_grid && this.selectedLLRevisionId){
            this.deleteButton.revisionId = this.selectedLLRevisionId.toString();
            this.deleteButton.openDeleteModal();
        }
        else if(this.draftsGrid && this.selectedLLRevisionId){
            this.deleteButtonDrafts.revisionId = this.selectedLLRevisionId.toString();
            this.deleteButtonDrafts.openDeleteModal();
        }
    }
    else if (this.deliveriesGrid && this.selectedLLRevisionFileName && args.item.id === 'tool-bar-send') {
      this.sendToFDAButton.showEsignatureModal();
    }
  }
}
